import type { NavigationListItemProps } from "@bonusx-global/bx-design-system";

export function enrichCitizenRoutesWithState(
  citizenRoutes: NavigationListItemProps[],
  locationPathname: string,
  onClickRouteCallback: (path?: string) => void
): NavigationListItemProps[] {
  return citizenRoutes.map(function mapCitizenRoutes(item) {
    let selected = false;
    if (item.path && locationPathname.length > item.path.length) {
      selected = locationPathname.startsWith(item.path);
    } else {
      selected = item.path === locationPathname;
    }
    return {
      ...item,
      selected,
      onClickRoute: onClickRouteCallback,
      subpaths: item.subpaths
        ? enrichCitizenRoutesWithState(item.subpaths, locationPathname, onClickRouteCallback)
        : undefined,
    };
  });
}
